module.exports = __webpack_public_path__ + "static/media/misebox.dbd44e77.webp";